<template>
  <div id="GameDetail">
    <a-carousel ref="endProsition" :autoplay="autoplay" :dots="false" :afterChange="loopChange">
      <div v-for="(item,index) in current.bannerImg" :key="index">
        <img class="bannerImg" :src="item.url" v-if="item.type==='img'">
        <video
          :index="index"
          v-else
          ref="videos"
          :poster="item.videourl"
          class="bannerImg"
          :src="item.url"
          controls
        ></video>
      </div>
    </a-carousel>
    <!-- 轮播图下标  -->
    <div class="loopIndex" ref="loopItem">
      <div
        class="loopItem"
        v-for="(item,index) in current.bannerImg"
        :key="index"
        @click="loopClick(item,index)"
      >
        <img
          v-if="item.type=='img'"
          :src="item.url"
          alt="index"
          :class="{'loopActive':loopIndex==index}"
        > 
        <img
          v-else
          :src="item.videourl"
          alt="index"
          :class="{'loopActive':loopIndex==index}"
        >  
      </div>
    </div>
    <!-- 游戏详情 -->
    <div class="detailInfo" :class="{'detailInfoLr':noRole}">
      <img class="jqRoleR" v-if="current.gameRoleR" :src="current.gameRoleR" alt>
      <div class="jq-logo" v-if="current.gameLogo">
        <!-- <video :src="jqvideo" controls ></video> -->
        <img :src="current.gameLogo" alt="街球logo">
      </div>
      <div class="introduce">
        <div class="introduceTitle">
          <img :src="gameTitle" alt="标题1">
        </div>
        <div class="introduceText">{{current.gameInfoText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel } from "ant-design-vue";
let that = null;
export default {
  name: "Banner",
  data() {
    return {
      // 街球
      jqInfo: {
        bannerImg: [
          { type: "video", url: require("@/assets/jq/jq-video.mp4"),videourl:require("@/assets/jq/jq_video_img.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_02.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_03.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_04.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_05.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_06.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_07.png") }
        ],
        gameLogo: require("@/assets/jq/jq-logo.png"),
        gameRoleR: require("@/assets/jq/jq-role-r.png"),
        gameInfoText:
          "《街球艺术》（繁体中文版名称：《街球對決》）是一款 3对3 真人竞技街球手游。游戏以“为竞技体验而生”为制作宗旨，采用美式街头风格，您将能在游戏里面跟着HIP-HOP音乐的节奏，用指尖去体验即时 3对3 篮球竞技的乐趣。"
        },
      // 腹黑
      fhInfo: {
        bannerImg: [
          { type: "img", url: require("@/assets/fh/fh_loop_01.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_02.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_03.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_04.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_05.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_06.jpg") },
          { type: "img", url: require("@/assets/fh/fh_loop_07.jpg") }
        ],
        gameLogo: require("@/assets/fh/fh_logo.png"),
        gameInfoText:
          "《腹黑Q神传》是一款Q萌卡通风格的MMORPG手游。在游戏中，有着200多种不同的卡通队友等待你去收集和展示；还有各种发色、帽子、翅膀、坐骑、套装道具，打造个性化的你；横行，竖列，单体，群体，上百种技能绚丽展现；通过巧妙的排兵布阵，就能起到以少胜多，以弱胜强的效果；简单的操作，动动手指就能享受游戏的乐趣！"
      },
      // 欢乐宠物店
      hlInfo: {
        bannerImg: [
          { type: "img", url: require("@/assets/hl/hl_loop_01.png") },
          { type: "img", url: require("@/assets/hl/hl_loop_02.png") },
          { type: "img", url: require("@/assets/hl/hl_loop_03.png") },
          { type: "img", url: require("@/assets/hl/hl_loop_04.png") },
          { type: "img", url: require("@/assets/hl/hl_loop_05.png") },
          { type: "img", url: require("@/assets/hl/hl_loop_06.png") }
        ],
        gameLogo: require("@/assets/hl/hl_logo.png"),
        gameInfoText:
          "《欢乐宠物店》里有可爱的猫咪、热情的狗狗、优雅的金鱼,还有漂亮的鸟儿等等等等,应有尽有。而且 作为店主,您可以打造自己的独一无二的宠物商店,不管是地板、地毯、墙纸还是植物摆放、颜色搭配,全都由你做主。您还能和自己的朋友们一起游戏,当然您还 可以去陌生人的商店里面拜访哦。"
      },
      // 大家来找碴
      djInfo: {
        bannerImg: [
          { type: "img", url: require("@/assets/dj/dj_loop_01.png") },
          { type: "img", url: require("@/assets/dj/dj_loop_02.png") },
          { type: "img", url: require("@/assets/dj/dj_loop_03.png") },
          { type: "img", url: require("@/assets/dj/dj_loop_04.png") },
          { type: "img", url: require("@/assets/dj/dj_loop_05.png") },
          { type: "img", url: require("@/assets/dj/dj_loop_06.png") }
        ],
        gameLogo: require("@/assets/dj/dj_logo.png"),
        gameInfoText:
          "《大家来找碴》是为你和你都朋友家人准备的精美游戏,游戏玩法经典、简单但是充满乐趣! 精美的真正高清画面设计,大量有趣的精致关卡, 有挑战性的游戏模式, 所有这一切都是为你准备的!游戏规则轻松有趣, 尤其适合你和你的家人、朋友一起玩, 分享乐趣!"
      },
      gameTitle: require("@/assets/title.png"),
      autoplay: false,
      first: [],
      last: [],
      invert: [],
      current: {},
      that: this,
      loopIndex: 0,
      noRole: false
    };
  },
  mounted() {
    // 获取first初始位置
    // let first = this.$refs.loopItem.children;
    // const arr = [...first];
    // this.first = arr.map((ele, index) => ({
    //   index,
    //   info: ele.getBoundingClientRect()
    // }));
    that = this; 
    // 获取当前是那个游戏
    this.currentGame();
  },
  watch: {
    "$route.query.gameName": function(newValue, oldValue) {
      document.documentElement.scrollTop = 0;
      that.loopIndex = 0;
      that.$refs.endProsition.goTo(this.loopIndex); 
      that.currentGame();
    }
  },
  methods: {
    // 更改当前的游戏
    currentGame() {
      const gameName = this.$route.query.gameName;
      this.current = {};
      switch (gameName) {
        case "街球艺术 3对3":
          Object.assign(this.current,this.jqInfo); 
          break;
        case "腹黑Q神传": 
          Object.assign(this.current,this.fhInfo); 
          break;
        case "欢乐宠物店":
          Object.assign(this.current,this.hlInfo);  
          break;
        case "大家来找碴":
          Object.assign(this.current,this.djInfo);  
          break;
        default:
          Object.assign(this.current,this.jqInfo);  
          break;
      } 
      if (!Reflect.has(this.current, "gameRoleR")) {
        this.noRole = true;
      }else{
        this.noRole = false;
      }
      setTimeout(() => {
        this.$refs.videos[0].play();
      }, 2000);
    },
    // 轮播图切换
    loopChange(arg) {
      this.loopIndex = arg;
      // 首先暂停所有视频
      if (Reflect.has(this.$refs, "videos")) {
        this.$refs.videos.forEach(ele => {
          ele.pause();
        });
      }
      // 循环判断当前是否Wie视频
      this.current.bannerImg.forEach((ele, index) => {
        if (ele.type === "video" && index === arg) {
          this.$refs.videos[index].play();
          this.$refs.videos[index].addEventListener("ended", () => {
            this.$refs.endProsition.next();
          });
        }
      });
    },
    loopClick(item, indexs) {
      this.$refs.endProsition.goTo(indexs);
      this.loopIndex = indexs;
      // // 设置结束位置last
      // {
      //   let el = this.$refs.loopItem.children;
      //   this.last = [];
      //   const arr = [...el];
      //   const last = this.$refs.endProsition.$el.getBoundingClientRect();
      //   const { top, left, width, height } = last;
      //   // 计算差值invert
      //   this.invert = this.first.map((ele, index) => {
      //     return {
      //       index,
      //       top: ele.info.top - top,
      //       left: ele.info.left - left,
      //       width:width,
      //       height:height
      //     };
      //   });
      // }

      // // 执行动画
      // {
      //   let el = this.$refs.loopItem.children;
      //   const arr = [...el];
      //   // 当前需要放大的元素的差值
      //   const { left , top ,width ,height}  = this.invert.filter((ele,index)=>index===indexs)[0];

      // }
    }
  },
  components: {
    aCarousel: Carousel
  }
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';

#GameDetail { 
  .loop {
    width: 100%;
    boxShadow();
  }
}

.bannerImg {
  width: 100%;
  max-height: 608px;

  img {
    height: 100%;
    width: 100%;
  }
}

.loopIndex {
  width: 100%;
  flex-around();
  cursor: pointer;
  padding-top: 30px;

  .loopItem {
    width: 140px;
    max-height: 78px;

    img, video {
      width: 100%;
      height: 100%;
    }

    .loopActive {
      border: 3px solid #fff;
    }
  }
}

.detailInfo {
  width: 100%;
  text-align: center;
  paddingPage();
  position: relative;

  .jqRoleR {
    position: absolute;
    right: 0;
    bottom: 0px;
    max-width: 35%;
    width: 35%;
  }

  .jq-logo {
    img {
      max-width: 500px;
    }
  }

  // background:url("../../assets/jq-bg.jpg");
  // background-repeat :no-repeat;
  // background-position :center center;
  // background-size 100% 100%
  // video{
  // position absolute
  // left:0;
  // top:0;
  // width:100%;
  // height:100%;
  // }
  // }
  .introduce {
    padding: 50px 0px 50px 0px;

    .introduceTitle {
      width: 54%; 
      img {
        width: 100%;
      }
    }

    .introduceText {
      width: 54%;
      text-align: left;
      text-indent: 34px;
      font-size: 18px;
      padding-top: 40px;
    }
  }
}

@media screen and (min-width: 1100px) {
  .detailInfoLr {
    flex-around();
    padding: 40px 0px !important;

    .introduce {
      .introduceTitle, .introduceText {
        width: 100% !important;
      }

      .introduceText {
        padding-top: 50px !important;
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .introduceTitle {
    width: 100% !important;
  }

  .introduceText {
    width: 100% !important;
  }

  .detailInfo {
    width: 100%;
    padding: 0 !important;
  }

  .jqRoleR {
    display: none;
  }

  .jq-logo {
    width: 100%;
    padding-top: 20px !important;

    img {
      width: 100%;
    }
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/Home/GameDetail.vue